module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1510-f20cfabb0c5e5de6b0b62e12a28b2931.png";